import GridStatus from '../../../../../components/Grid/GridStatus';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import '../../../../../theme/reorder.css';
import { IonButton, IonButtons, IonCard, IonCardContent, IonContent, IonFab, IonFabButton, IonFooter, IonHeader, IonIcon, IonInput, IonLoading, IonModal, IonPage, IonReorder, IonReorderGroup, IonSelect, IonSelectOption, IonTitle, IonToast, IonToggle, ItemReorderEventDetail, useIonViewDidEnter } from '@ionic/react';
import { add, arrowBack, cardOutline, checkmarkCircleOutline, removeCircleOutline, eyeOutline, informationCircleOutline, reorderTwo, trash } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import OnboardingContextBanner from '../../../../../components/Onboarding/OnboardingContextBanner';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { OnboardingContext } from '../../../../../contexts/OnboardingContext';
import { empresaConfiguracoesAlterar, onboardingAtualizarEtapa, ordernarItemFormaPagamentoEmpresa, removerFormaPagamentoEmpresa, requestService } from '../../../../../Utils/Services';
import "./FormaPagamento.css";

type Props = {
  onDismiss: () => void;
};

const FormaPagamento: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaFormaPagamento, setListaFormaPagamento] = useState<any>([]);

  const [showDetalhes, setShowDetalhes] = useState(false);
  const [index, setIndex] = useState("");
  const [nome, setNome] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");


  const { loja, setLoja } = useContext(MessageContext);
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const podeOrdenar = acessos?.configuracoes === 'edicao';
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);


  const inputRef = useRef<any>(null);
  const [tipo, setTipo] = useState('');
  const [chavePix, setChavePix] = useState('');
  const [exibirPdv, setExibirPdv] = useState(false);
  const [exibirDelivery, setExibirDelivery] = useState(false);

  const opcoesPagamento = [
    'Dinheiro',
    'Cartão de Crédito',
    'Cartão de Débito',
    'Pix',
    'Pix Automatizado',
    'Vale Refeição',
    'Vale Alimentação',
    'Mercado Pago Pix',
    'Mercado Pago Crédito',
    'Mercado Pago Débito'


  ];

  const [mostartAlerta] = useIonAlert();

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    setListaFormaPagamento(dadosEmpresa.formaPagamento || []);
  });

  function deletarFormaPagamento(indice: any) {

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const delFormaPagamento = async () => {
      setShowLoading(true);
      try {
        const resp = await fetch(removerFormaPagamentoEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
          {
            method: removerFormaPagamentoEmpresa.method,
            headers: [
              ["token", token]
            ],
            body: JSON.stringify({ 'index': indice }),
            credentials: 'include'
          });
        const response = await resp.json();

        if (response) {
          setListaFormaPagamento(response.message.Attributes.formaPagamento || []);
          dadosEmpresa.formaPagamento = response.message.Attributes.formaPagamento;
          setDadosEmpresa(dadosEmpresa);


          console.log("retorno", response);
          setTextToast("Forma de pagamento removida com sucesso.");
          setShowToast(true);
        }
        // carregarConta();
      } catch (err) {
        console.log(err);
        setTextToast("Ocorreu um erro ao remover.");
        setShowToast(true);
      } finally {
        setShowLoading(false);
      }
    }

    delFormaPagamento();

  }

  function handleReorder(event: CustomEvent<ItemReorderEventDetail>) {
    if (!podeOrdenar || showLoading || event.detail.from === event.detail.to) {
      event.detail.complete(false);
      return;
    }

    // Before complete is called with the items they will remain in the
    // order before the drag
    //console.log('Before complete', listaItemCatalogoProdutos);

    // Finish the reorder and position the item in the DOM based on
    // where the gesture ended. Update the items variable to the
    // new order of items
    setListaFormaPagamento(event.detail.complete(listaFormaPagamento));

    // After complete is called the items will be in the new order
    //console.log('After complete', listaItemCatalogoProdutos);


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const ordItemFormaPagamento = async () => {
      const resp = await fetch(ordernarItemFormaPagamentoEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: ordernarItemFormaPagamentoEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'formaPagamento': listaFormaPagamento }),
          credentials: 'include'
        });
      const retorno = await resp.json();
      console.log("retorno ordenar", retorno);

      if (retorno && retorno.Item?.Attributes) {
        setTextToast("Ordenação alterada com sucesso.");
        setShowToast(true);
        setListaFormaPagamento(retorno.Item?.Attributes?.formaPagamento || []);
        dadosEmpresa.formaPagamento = retorno.Item?.Attributes?.formaPagamento;
        setDadosEmpresa(dadosEmpresa);

      }
      else {
        setTextToast("Ocorreu um erro ao ordernar.");
        setShowToast(true);
      }
    }

    ordItemFormaPagamento();

  }


  const novaFormaPagamento = () => {
    setIndex("");
    setNome("");
    setTipo("");
    setChavePix("");
    setExibirPdv(false);
    setExibirDelivery(false);
    setShowDetalhes(true);
  };

  const loadFormaPagamento = () => {
    if (!listaFormaPagamento?.length) return (
      <div className="formas-empty"><IonIcon icon={cardOutline} aria-hidden="true" /><h2>Nenhuma forma de pagamento cadastrada</h2><p>Adicione as opções de pagamento aceitas pela sua loja.</p></div>
    );
    return <IonReorderGroup role="rowgroup" disabled={!podeOrdenar || showLoading} onIonItemReorder={handleReorder}>
      {listaFormaPagamento.map((value: any, itemIndex: any) => {
        const editar = () => {
          if (!podeOrdenar || showLoading) return;
          setIndex(itemIndex);
          setNome(value.nome);
          setTipo(value.tipo);
          setChavePix(value.chavePix || '');
          setExibirPdv(value.exibirPdv);
          setExibirDelivery(value.exibirDelivery);
          setShowDetalhes(true);
        };
        return <div key={itemIndex} role="row" className={`formas-row ${podeOrdenar ? 'formas-row-editable' : ''}`}
          tabIndex={podeOrdenar && !showLoading ? 0 : undefined}
          aria-label={podeOrdenar ? `Editar ${value.nome}` : undefined}
          onClick={editar} onKeyDown={(event) => {
            if (event.target === event.currentTarget && (event.key === 'Enter' || event.key === ' ')) {
              event.preventDefault();
              editar();
            }
          }}>
          {podeOrdenar && <div className="formas-order" role="cell" onClick={(event) => event.stopPropagation()}>
            <IonReorder className="list-reorder-handle" aria-label={`Ordenar ${value.nome || 'item'}`}><IonIcon icon={reorderTwo} aria-hidden="true" /></IonReorder>
          </div>}
          <div className="formas-name" role="cell"><strong>{value.nome}</strong><span className="formas-payment-type">{value.tipo}</span></div>
          <div className="formas-status formas-pdv" role="cell">
            <GridStatus tone={value.exibirPdv ? 'success' : 'neutral'} icon={value.exibirPdv ? checkmarkCircleOutline : removeCircleOutline}>
              <span className="formas-mobile-label">PDV: </span>{value.exibirPdv ? 'Ativo' : 'Inativo'}
            </GridStatus>
          </div>
          <div className="formas-status formas-delivery" role="cell">
            <GridStatus tone={value.exibirDelivery ? 'success' : 'neutral'} icon={value.exibirDelivery ? checkmarkCircleOutline : removeCircleOutline}>
              <span className="formas-mobile-label">Delivery: </span>{value.exibirDelivery ? 'Ativo' : 'Inativo'}
            </GridStatus>
          </div>
          {podeOrdenar && <div className="formas-actions" role="cell" onClick={(event) => event.stopPropagation()}>
            <IonButton fill="clear" aria-label={`Remover ${value.nome}`} onClick={() => mostartAlerta({
              backdropDismiss: false,
              header: 'Remover item',
              message: 'Deseja <strong>remover</strong>?',
              buttons: [{ text: 'Cancelar', role: 'cancel' }, { text: 'Confirmar', cssClass: 'primary', handler: () => deletarFormaPagamento(itemIndex) }],
            })}><IonIcon slot="icon-only" icon={trash} aria-hidden="true" /></IonButton>
          </div>}
        </div>;
      })}
    </IonReorderGroup>;
  };

  const validate = () => {
    let isValid = true;
    let errors: Array<{ message: string }> = [];

    if (!tipo) {
      isValid = false;
      errors.push({ message: `Tipo não pode estar vazio.` });
    }

    if (!nome) {
      isValid = false;
      errors.push({ message: `Nome não pode estar vazio.` });
    }

    // Chave PIX não é obrigatória



    return { isValid, errors };
  };


  async function salvar() {

    const { isValid, errors } = validate();

    if (!isValid && errors.length > 0) {
      console.log('Erros de validação:', errors);

      // Mapeia o array de erros e retorna um array de strings para o IonToast
      const errorMessages: any = errors.map((error) => `${error.message}`);
      setTextToast(errorMessages.join('<br>'));
      setShowToast(true);
      return;
    }

    const formaPagamento = {
      nome,
      tipo,
      ...(tipo === 'Pix' && chavePix?.trim() ? { chavePix: chavePix.trim() } : {}),
      exibirPdv,
      exibirDelivery,
    };

    const objectRequest = { index, formaPagamento };
    console.log("objectRequest", objectRequest);

    let id = loja;

    console.log("id", id);

    setShowLoading(true);

    await requestService(
      empresaConfiguracoesAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?formapagamento=sim"),
      {
        method: empresaConfiguracoesAlterar.method,
        body: JSON.stringify(objectRequest),
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        console.log(response);
        if (response) {
          setTextToast("Cadastro realizado com sucesso.");
          setShowToast(true);

          console.log("response", response);

          setListaFormaPagamento(response.message.Attributes.formaPagamento || []);
          dadosEmpresa.formaPagamento = response.message.Attributes.formaPagamento;
          setDadosEmpresa(dadosEmpresa);

          // Marcar etapa do onboarding como concluída
          if (onboardingData && !onboardingData.onboarding_concluido) {
            const urlOnb = onboardingAtualizarEtapa.url
              .replace("{empresa_id}", onboardingData.empresa_id.replaceAll("#", "%23"));
            requestService(urlOnb, {
              method: onboardingAtualizarEtapa.method,
              body: JSON.stringify({ etapa_id: 'forma_pagamento', status: 'concluido' }),
              headers: [["token", window.localStorage.getItem("token")]],
              credentials: 'include'
            }, history, (r: any) => { if (r) setOnboardingData(r); }, () => { });
          }

          //carregarConta();
          setShowDetalhes(false);

        } else if (response.status === 400) {
          console.log(response);
          setTextToast("Ocorreu um erro ao efetuar o cadastro.");
          setShowToast(true);

        }
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast("Ocorreu um erro ao efetuar o cadastro.");
        setShowToast(true);
        setShowLoading(false);
      })


  }

  return (

    <IonPage className="formas-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="formas-toolbar">
          <IonButtons slot="start"><IonButton aria-label="Voltar" onClick={() => history.goBack()}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton></IonButtons>
          <IonTitle>Formas de pagamento</IonTitle>
        </IonToolbar>
        <OnboardingContextBanner />
      </IonHeader>
      <IonContent className="formas-content">
        {podeOrdenar && <IonFab className="formas-mobile-add" vertical="bottom" horizontal="center" slot="fixed">
          <IonFabButton color="tertiary" className="custom-fab-button" aria-label="Nova forma de pagamento" onClick={novaFormaPagamento}><IonIcon color="light" icon={add} aria-hidden="true" /></IonFabButton>
        </IonFab>}
        <main className="formas-container">
          <header className="formas-intro">
            <div><h1>Formas de pagamento</h1><p>Defina como seus clientes podem pagar no PDV e no delivery.</p></div>
            {podeOrdenar && <IonButton className="formas-add" onClick={novaFormaPagamento}><IonIcon icon={add} slot="start" aria-hidden="true" />Nova forma de pagamento</IonButton>}
          </header>
          <section className="formas-card" aria-labelledby="formas-list-title">
            <header className="formas-list-header"><span className="formas-section-icon"><IonIcon icon={cardOutline} aria-hidden="true" /></span><div><h2 id="formas-list-title">Pagamentos da loja</h2><p>{listaFormaPagamento.length} {listaFormaPagamento.length === 1 ? 'forma cadastrada' : 'formas cadastradas'}</p></div></header>
            <div className={`formas-table ${podeOrdenar ? 'formas-table-editable' : ''}`} role={listaFormaPagamento.length ? 'table' : undefined} aria-label="Formas de pagamento">
              {listaFormaPagamento.length > 0 && <div className="formas-table-head" role="rowgroup"><div className="formas-row" role="row">
                {podeOrdenar && <div role="columnheader" aria-label="Ordenação" />}
                <div role="columnheader">Forma de pagamento</div><div role="columnheader">PDV</div><div role="columnheader">Delivery</div>
                {podeOrdenar && <div role="columnheader" className="formas-actions-title">Ações</div>}
              </div></div>}
              {loadFormaPagamento()}
            </div>
          </section>
        </main>

        <IonModal onDidPresent={() => {
          if (inputRef.current) {
            inputRef.current.setFocus();
          }
        }} isOpen={showDetalhes} onDidDismiss={() => {
          setShowDetalhes(false);
          setIndex("");
          setNome("");
          setChavePix("");
        }}>


          <>
            <IonHeader className="ion-no-border">
              <IonToolbar>
                <IonButtons slot="start">
                  <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowDetalhes(false)} />
                </IonButtons>
                <IonTitle>{index === "" ? "Nova forma de pagamento" : "Editar forma de pagamento"}</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent className="pagamento-modal-content">
              <div className="pagamento-form-container">
                <IonCard className="pagamento-form-card">
                  <IonCardContent>
                    <div className="pagamento-section-header">
                      <div className="pagamento-section-icon pagamento-section-icon--primary">
                        <IonIcon icon={cardOutline} />
                      </div>
                      <div>
                        <div className="pagamento-section-title">DADOS DA FORMA DE PAGAMENTO</div>
                        <div className="pagamento-section-subtitle">Escolha o tipo e defina como ele será identificado</div>
                      </div>
                    </div>

                    <div className="pagamento-fields-grid">
                      <div className="pagamento-field">
                        <label className="pagamento-field-label">Tipo*</label>
                        <IonSelect
                          className="pagamento-field-input"
                          interface="popover"
                          placeholder="Selecione"
                          value={tipo}
                          onIonChange={(e) => {
                            setTipo(e.detail.value);

                            // Resetar valores quando tipo bloqueia funcionalidades
                            const valorNormalizado = (e.detail.value || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

                            if (valorNormalizado.includes('pix automatizado')) {
                              setExibirPdv(false);
                            }
                            if (valorNormalizado.includes('mercado pago')) {
                              setExibirDelivery(false);
                            }
                          }}
                        >
                          {opcoesPagamento.map((opcao, index) => (
                            <IonSelectOption key={index} value={opcao}>
                              {opcao}
                            </IonSelectOption>
                          ))}
                        </IonSelect>
                      </div>

                      <div className="pagamento-field">
                        <label className="pagamento-field-label">Nome*</label>
                        <IonInput
                          className="pagamento-field-input"
                          placeholder="Digite o nome da forma de pagamento"
                          value={nome}
                          ref={(ref) => inputRef.current = ref}
                          autoCorrect='true'
                          autoCapitalize='true'
                          required
                          onIonInput={(e: any) => setNome(e.target.value)}
                        />
                      </div>
                    </div>

                    {tipo === 'Pix' && (
                      <div className="pagamento-field pagamento-field--last">
                        <label className="pagamento-field-label">Chave PIX</label>
                        <IonInput
                          className="pagamento-field-input"
                          placeholder="Digite a chave PIX"
                          value={chavePix}
                          autoCorrect='true'
                          autoCapitalize='true'
                          onIonInput={(e: any) => setChavePix(e.target.value)}
                        />
                        <div className="pagamento-field-help">Opcional. Informe a chave que será apresentada ao cliente.</div>
                      </div>
                    )}
                  </IonCardContent>
                </IonCard>

                <IonCard className="pagamento-form-card">
                  <IonCardContent>
                    <div className="pagamento-section-header">
                      <div className="pagamento-section-icon pagamento-section-icon--neutral">
                        <IonIcon icon={eyeOutline} />
                      </div>
                      <div>
                        <div className="pagamento-section-title">DISPONIBILIDADE</div>
                        <div className="pagamento-section-subtitle">Defina onde esta forma de pagamento poderá ser utilizada</div>
                      </div>
                    </div>

                    <div className={`pagamento-toggle-row${tipo === 'Pix Automatizado' ? " pagamento-toggle-row--disabled" : ""}`}>
                      <div>
                        <div className="pagamento-toggle-label">Exibir no PDV</div>
                        <div className="pagamento-toggle-desc">
                          {tipo === 'Pix Automatizado'
                            ? "Pix Automatizado está disponível somente no Delivery."
                            : "Disponibilizar nos pedidos feitos pelo ponto de venda."}
                        </div>
                      </div>
                      <IonToggle
                        checked={exibirPdv}
                        disabled={tipo === 'Pix Automatizado'}
                        onIonChange={(e: any) => setExibirPdv(e.detail.checked)}
                      />
                    </div>

                    <div className="pagamento-divider" />

                    <div className={`pagamento-toggle-row${(tipo || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes('mercado pago') ? " pagamento-toggle-row--disabled" : ""}`}>
                      <div>
                        <div className="pagamento-toggle-label">Exibir no Delivery</div>
                        <div className="pagamento-toggle-desc">
                          {(tipo || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes('mercado pago')
                            ? "Mercado Pago está disponível somente no PDV."
                            : "Disponibilizar nos pedidos realizados pelo catálogo digital."}
                        </div>
                      </div>
                      <IonToggle
                        checked={exibirDelivery}
                        disabled={(tipo || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes('mercado pago')}
                        onIonChange={(e: any) => setExibirDelivery(e.detail.checked)}
                      />
                    </div>

                    {!tipo && (
                      <div className="pagamento-info-box">
                        <IonIcon icon={informationCircleOutline} />
                        <span>Selecione um tipo para visualizar as regras de disponibilidade.</span>
                      </div>
                    )}
                  </IonCardContent>
                </IonCard>
              </div>
            </IonContent>

            <IonFooter className="ion-no-border">
              <IonToolbar className="pagamento-modal-footer">
                <IonButton onClick={() => salvar()} expand="block" type="submit">Salvar</IonButton>
              </IonToolbar>
            </IonFooter>
          </>

        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

    </IonPage>
  );


};

export default FormaPagamento;
